import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, CircularProgress, Grid } from "@mui/material";
import styled from "styled-components";
import useQueryParams from "../../hooks/use-query-params";
import request from "../../utils/request";
import Icon from "../../components/icon";
import Flex from "../../components/flex";
import { getNotionRedirectUrl } from "./utils";
import notion from "../../assets/icons/notion";

const H1 = styled.h1`
    font-size: 22px;
    font-weight: 500;
    color: ${({ theme }) => theme.palette.primary.main};
`;

const Span = styled.span`
    font-size: 16px;
    font-weight: 300;
    opacity: 0.35;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const NotionOauth = () => {
    const query = useQueryParams();
    const navigate = useNavigate();

    const integrateMethod = async () => {
        const code = query.get("code");
        const state = query.get("state");

        try {
            await request(
                `/api/notion/oauth?code=${code}&state=${state}&redirect_uri=${getNotionRedirectUrl()}`
            );
            const notionSettings = await request(`/api/notion`);
            localStorage.setItem("widt", new Date().valueOf().toString());
            if (
                notionSettings &&
                notionSettings.setupFields &&
                notionSettings.notionDatabases &&
                notionSettings.setupFields.length > 0 &&
                notionSettings.notionDatabases.length > 0 &&
                Object.keys(notionSettings.notionDatabases[0]).length > 0
            ) {
                navigate("/integrations/success/notion");
            } else {
                navigate("/integrations/setup/notion");
            }
        } catch (e) {
            navigate("/integrations/failure/notion");
        }
    };

    React.useEffect(() => {
        integrateMethod();
    }, [query]);

    return (
        <Box mt={10}>
            <Grid
                container
                spacing={3}
                direction="column"
                alignItems="center"
                justifyContent="center"
            >
                <Grid item>
                    <Icon svg={notion} width="250px" height="auto" />
                </Grid>
                <Grid item style={{ textAlign: "center" }}>
                    <H1>Plugging in Notion</H1>
                    <Span>You will be redirected momentarily</Span>
                </Grid>
                <Grid item style={{ marginTop: "40px" }}>
                    <Flex justifyContent="center">
                        <CircularProgress size={50} />
                    </Flex>
                </Grid>
            </Grid>
        </Box>
    );
};

export default NotionOauth;
